// extracted by mini-css-extract-plugin
export default {"sticky":"Header-module__[local]___qZEiD","title":"Header-module__[local]___mAAUF","header-info":"Header-module__[local]___Wv7O4"};